module.exports = __webpack_public_path__ + "static/icons/exitoso.11f0fbe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/exitoso.gif
// module id = Hm8Y
// module chunks = 1